import axios from 'axios';
import qs from 'qs';

export const getStudents = (params: Record<string, any>) =>
  axios.get(`/api/v1/students?${qs.stringify(params)}`);

export const createStudent = (data: any) =>
  axios.post('/api/v1/students', data);

export const getStudentById = (studentId: string) =>
  axios.get(`/api/v1/students/${studentId}`);

export const updateStudentById = ({
  studentId,
  data,
}: {
  studentId: string;
  data: any;
}) => axios.put(`/api/v1/students/${studentId}`, data);

export const getCoursesByStudentId = (studentId: string) =>
  axios.get(`/api/v1/students/${studentId}/courses`);

export const grantStudentCoursesAccess = (studentId: string, data: any) =>
  axios.post(`/api/v1/students/${studentId}/courses/access`, data);

export const issueStudentCertificate = (
  studentId: string,
  data: { courseId: string },
) => axios.post(`/api/v1/students/${studentId}/certificates`, data);

export const importStudents = ({
  data,
  config = {},
}: {
  data: any;
  config?: import('axios').AxiosRequestConfig;
}) =>
  axios.post('/api/v1/students/import', data, {
    ...config,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const finishImportStudents = (data: any) =>
  axios.post('/api/v1/students/import/finish', data);

export const removeStudentById = (studentId: string) =>
  axios.delete(`/api/v1/students/${studentId}`);

export const removeStudentCourses = (studentId: string) =>
  axios.delete(`/api/v1/students/${studentId}/remove-courses`);

export const removeStudentReviews = (studentId: string) =>
  axios.delete(`/api/v1/students/${studentId}/remove-reviews`);

export const removeStudentRatings = (studentId: string) =>
  axios.delete(`/api/v1/students/${studentId}/remove-ratings`);

export const removeStudentReports = (studentId: string) =>
  axios.delete(`/api/v1/students/${studentId}/remove-reports`);

export const exportStudents = (data: any) =>
  axios.post('/api/v1/students/export', data, {
    responseType: 'blob',
  });

export const getStudentsStats = (period: any) =>
  axios.get(`/api/v1/students/stats/registrations?period=${period}`);
